import { render } from "./MyHeader.vue?vue&type=template&id=66b92b46"
import script from "./MyHeader.vue?vue&type=script&lang=js"
export * from "./MyHeader.vue?vue&type=script&lang=js"

import exportComponent from "D:\\data\\work\\interfase\\crypto\\demo\\bio-web-client\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__